export default __webpack_public_path__ + "static/ProductSans-Regular-0aabd86cbca3884e4740c01c2eba399f.woff2";